// 502 from /api/opds/* routes means the OPDS server itself isn't reachable
// (proxy could not connect or upstream returned 5xx). Distinguished from
// 4xx (auth / not-found) which pass through and surface as real errors.
export function isUpstreamDown(error: string | null | undefined): boolean {
  if (!error) return false;
  return error.includes('502') || error.includes('Upstream returned');
}

export const LIBRARY_DOWN_ALERT =
  'Библиотека прилегла отдохнуть — сервер сейчас недоступен. Вы знаете к кому обратиться...';

export function formatOpdsError(e: unknown): string {
  const msg = e instanceof Error ? e.message : String(e ?? 'неизвестная ошибка');
  if (isUpstreamDown(msg)) return LIBRARY_DOWN_ALERT;
  return msg;
}
